export const serverURI = 'https://www.utech.com.my:5888';
export const bankslipURI = 'https://utech.oss-ap-southeast-1.aliyuncs.com/bankslips/';
export const storageURI = 'https://utech.oss-ap-southeast-1.aliyuncs.com/';

export const OrderStatus = ['Ordered', 'Paid', 'Shipped', 'Canceled'];
export const OrderFilter = ['All', ...OrderStatus];

export const QuotationStatus = ['Submitted', 'Canceled', 'Approved'];
export const QuotationFilter = ['All', ...QuotationStatus];


export const firebaseConfig = {
  apiKey: "AIzaSyAhSyi87OtOJS2ZQsaWBRsAkIPaOuCSMrs",
  authDomain: "utech-admin.firebaseapp.com",
  databaseURL: "https://utech-admin.firebaseio.com",
  projectId: "utech-admin",
  storageBucket: "utech-admin.appspot.com",
  messagingSenderId: "743156533084"
};

export const metaToString = (meta) => {
  let strArray = meta.split('-');
  let newArray = strArray.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return newArray.join(' ');
}

export const capitalizeKey = text => text
  .split('_')
  .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
  .join(' ');
